var _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaricon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "car_icon",
    "data-name": "car icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28.372,
    viewBox: "0 0 36 28.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0.75 14.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M20.2,271.386l-3.621-3.621a3.729,3.729,0,0,0-2.652-1.1H11.416a.75.75,0,1,0,0,1.5h2.508a2.266,2.266,0,0,1,1.59.658l2.341,2.341H11.416a.75.75,0,0,0,0,1.5h8.25a.751.751,0,0,0,.531-1.281Z",
    transform: "translate(-10.666 -266.667)",
    fill: "#282828"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(1.5 22.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M29.583,374.083a.75.75,0,0,0-.75.75v2.25a.751.751,0,0,1-.75.75h-4.5a.751.751,0,0,1-.75-.75v-3a.75.75,0,1,0-1.5,0v3a2.253,2.253,0,0,0,2.25,2.25h4.5a2.253,2.253,0,0,0,2.25-2.25v-2.25A.75.75,0,0,0,29.583,374.083Z",
    transform: "translate(-21.333 -373.333)",
    fill: "#282828"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 8.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M32.6,182.919c-2.067-1.081-6.706-1.585-14.6-1.585s-12.529.5-14.6,1.585C1.048,184.149,0,186.2,0,189.584a26.717,26.717,0,0,0,.775,6.193.748.748,0,0,0,.724.557H8.073l2.841,1.421a.752.752,0,0,0,.336.08h13.5a.741.741,0,0,0,.334-.08l2.843-1.421H34.5a.748.748,0,0,0,.725-.557A26.717,26.717,0,0,0,36,189.584C36,186.2,34.951,184.149,32.6,182.919Zm1.311,11.914H27.751a.743.743,0,0,0-.336.08l-2.843,1.421H11.427l-2.841-1.421a.752.752,0,0,0-.336-.08H2.094a25.791,25.791,0,0,1-.594-5.25c0-2.825.753-4.371,2.6-5.336,1.8-.939,6.474-1.414,13.9-1.414s12.106.476,13.9,1.414c1.844.964,2.6,2.511,2.6,5.336A25.922,25.922,0,0,1,33.907,194.834Z",
    transform: "translate(0 -181.334)",
    fill: "#282828"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(25.5 14.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M371.672,271.167h-6.44l2.34-2.341a2.269,2.269,0,0,1,1.592-.658h2.508a.75.75,0,0,0,0-1.5h-2.508a3.729,3.729,0,0,0-2.652,1.1l-3.621,3.621a.751.751,0,0,0,.531,1.281h8.25a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-362.672 -266.667)",
    fill: "#282828"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(9 14.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M145.926,267.1a.751.751,0,0,0-.68-.432h-16.5a.75.75,0,0,0-.576,1.23l3.75,4.5a.751.751,0,0,0,.576.27h9a.751.751,0,0,0,.576-.27l3.75-4.5A.748.748,0,0,0,145.926,267.1Zm-4.782,4.068h-8.3l-2.5-3h13.3Z",
    transform: "translate(-127.996 -266.667)",
    fill: "#282828"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M72.607,64.285c-.854-1.962-3.709-8.429-4.7-9.273-1.238-1.052-4.782-1.679-9.486-1.679h-1.5c-4.7,0-8.249.627-9.486,1.677-.993.845-3.851,7.311-4.7,9.273a.751.751,0,0,0,1.377.6c1.693-3.9,3.765-8.231,4.3-8.727.577-.491,3.021-1.322,8.514-1.322h1.5c5.493,0,7.937.831,8.511,1.319.535.5,2.607,4.83,4.3,8.73a.75.75,0,0,0,1.377-.6Z",
    transform: "translate(-42.668 -53.333)",
    fill: "#282828"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(25.5 22.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M370.915,373.333a.75.75,0,0,0-.75.75v3a.751.751,0,0,1-.75.75h-4.5a.751.751,0,0,1-.75-.75v-2.25a.75.75,0,1,0-1.5,0v2.25a2.253,2.253,0,0,0,2.25,2.25h4.5a2.253,2.253,0,0,0,2.25-2.25v-3A.75.75,0,0,0,370.915,373.333Z",
    transform: "translate(-362.665 -373.333)",
    fill: "#282828"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaricon);
export default __webpack_public_path__ + "static/media/caricon.087596c04df0387af8d259f520ee3494.svg";
export { ForwardRef as ReactComponent };